var _style, _defs, _defs2, _defs3, _path, _defs4, _defs5, _defs6, _path2, _defs7, _defs8, _defs9, _path3, _defs0, _defs1, _defs10, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavbarNeuron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 304 300",
    style: {
      enableBackground: "new 0 0 304 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000175297285833035863720000018315394070330348961_);}\r\n\t.st1{clip-path:url(#SVGID_00000013896198726435818570000002127508874926736291_);}\r\n\t.st2{clip-path:url(#SVGID_00000064315230679943802330000009433753534813775542_);}\r\n\t.st3{fill:#3098D8;}\r\n\t.st4{clip-path:url(#SVGID_00000127026851697893257360000000973848320789642931_);}\r\n\t.st5{clip-path:url(#SVGID_00000143581863659910392260000014578897830586347188_);}\r\n\t.st6{clip-path:url(#SVGID_00000003792883275007022560000012602683995920336277_);}\r\n\t.st7{fill:#ECECEC;}\r\n\t.st8{clip-path:url(#SVGID_00000152256860186250169600000000894096183707353744_);}\r\n\t.st9{clip-path:url(#SVGID_00000062182001798868718970000012550150046073861762_);}\r\n\t.st10{clip-path:url(#SVGID_00000157268721546866879260000002169090754862677134_);}\r\n\t.st11{clip-path:url(#SVGID_00000053530665102239549570000015396067811745388676_);}\r\n\t.st12{clip-path:url(#SVGID_00000143609416675893934490000012250949629096046508_);}\r\n\t.st13{clip-path:url(#SVGID_00000172422036347982639070000014261800405163591085_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 304,
    height: 300
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178891371261177273930000013230768403168106933_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178891371261177273930000013230768403168106933_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000183232959503468435620000010871171020312914577_",
    x: 5.2,
    y: 17.3,
    transform: "matrix(0.9298 -0.368 0.368 0.9298 -48.889 66.221)",
    width: 288,
    height: 288
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158709226497827263810000006530088853441589639_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183232959503468435620000010871171020312914577_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000158709226497827263810000006530088853441589639_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000096738574430545813000000011475449732009996699_",
    x: 5.2,
    y: 17.3,
    transform: "matrix(0.9298 -0.368 0.368 0.9298 -48.889 66.221)",
    width: 288,
    height: 288
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000048462263874719629480000006364872223743599502_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096738574430545813000000011475449732009996699_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000048462263874719629480000006364872223743599502_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M243,119c-1.1,0.3-2.3,0.6-3.4,0.9c0.7,0.2,1.3,0.3,1.9,0.5c6,1.9,11.6,5.1,16.5,9 c5,3.8,8.6,9,11.8,14.1c0.9,1.5,0.4,3.5-1.1,4.4c-1.4,0.8-3.3,0.5-4.2-0.7l-0.3-0.3c-3.3-4.3-6.7-8.4-11.2-11.1 c-4.4-2.9-9.2-5.1-14.4-6.2c-5.2-1.2-10.5-1.7-16-1.5h-0.1c-6.6,0.2-12.3,5.3-12.9,11.8c-0.6,7.4,0.1,14.7,2.1,21.7 c2.8,10.4,10.1,19,19.8,23.9c8.5,4.2,19.5,9.3,27,11.2c6.9,1.8,13.9,2.9,20.9,2.7c7-0.1,13.8-1.6,19.5-5.2 c1.6-1,3.6-0.6,4.6,0.9c0.9,1.4,0.5,3.3-0.8,4.3c-6.8,5-15,7.3-22.9,8c-8,0.7-15.9,0-23.5-1.3c-1.1-0.2-2-0.5-3.1-0.7 c2.8,3.4,5.3,6.9,7.4,10.7c3.5,6.5,5.7,13.7,6.4,20.9c0.2,1.8-1.1,3.3-2.9,3.6c-1.7,0.1-3.2-1.1-3.5-2.7 c-2.1-12.8-9.8-23.8-20-31.9c-4.2-3.4-8.8-6.3-13.7-9l-0.2-0.1c-10.6-4.5-23-3.9-33.1,2c-7,4.1-13.3,9.1-18.3,14.9 c-5.5,6.4-6.3,15.6-2.1,22.6c0.2,0.3,0.4,0.6,0.6,0.9c3.1,4.3,6.7,7.9,10.9,10.6c4.2,2.7,9,4,14.8,4.9 c2.8,0.5,6.1,1.1,9.2,2.4c3.3,1.2,5.9,3.7,8.1,6.2c1.2,1.3,1.1,3.4-0.4,4.5c-1.3,1.1-3.2,1-4.4-0.2l-0.2-0.1 c-3.4-3.5-7.7-4.5-13.6-4.9c-5.7-0.4-12.6-1.4-18.4-4.5c-1.8-0.9-3.6-2-5.3-3.2c0,0.4,0,0.9,0,1.3c-0.5,3.8-1.3,6.8-1.1,9 c0.2,4.8,3.7,8.8,9,13.1c2.5,2.2,5.3,4.8,7.4,7.9c2.1,3.2,3.4,7,3.9,10.6c0.3,1.8-1,3.4-2.7,3.6c-1.7,0.3-3.3-0.8-3.7-2.4 c-1.2-5.8-4.8-9.8-10.1-13.6c-2.6-1.9-5.6-4-8.1-7.1c-2.6-3-4.6-6.8-5.2-11.1c-0.2-1.3-0.2-2.5-0.1-3.7 c-1,1.6-2.1,3.1-3.3,4.5c-2.2,2.7-4.6,5.1-6.7,7.4c-1.7,1.6-2.9,3.6-3.6,6.1c-1.5,4.9-1,11.1,0.5,16.4l0.1,0.3 c0.4,1.7-0.5,3.5-2.3,4c-1.6,0.4-3.2-0.4-3.9-1.9c-2.5-6.4-4.1-13.1-2.9-20.6c0.6-3.7,2.2-7.5,4.8-10.7 c2.1-2.5,4.1-4.8,5.7-7.1c3.3-4.7,5.2-9.4,5.3-14.5c0-0.4,0-0.8-0.1-1.3c-1.1-9.2-8.2-16.6-17.2-19.2 c-3.8-1.2-7.7-2.1-10-2.3c-0.4,0-1.2,0-2.1,0.1c-11.6,1.2-22.4,6.7-30.2,15.4c-0.7,0.8-1.1,1.2-1.1,1.2 c-3.8,4.3-7.3,9.1-9.4,14c-1,2.4-1.7,4.8-1.7,6.9c0,1.2,0.2,1.9,0.5,3.1c0.5,1.9,0.9,3.7,1,5.6c0.3,7.6-3,14.2-7.8,19.4 c-1.2,1.3-3.2,1.5-4.5,0.3c-1.3-1.1-1.4-2.9-0.5-4.2l0.2-0.3c3.1-4.1,4.9-9.7,4.1-14.2c-0.2-1.2-0.6-2.2-1-3.3 c-0.7-1.7-1.3-3.8-1.4-5.7c-0.3-3.9,0.5-7.6,1.6-10.9c0.7-2,1.5-3.8,2.3-5.6c-4.3,0.3-8.5,0-12.1-0.2 c-6.7-0.2-12,0.7-16.2,5.3c-4.4,4.3-7.1,10.8-9.9,17l-0.1,0.2c-0.7,1.7-2.6,2.4-4.3,1.7c-1.5-0.7-2.3-2.5-1.7-4 c2.6-6.9,4.6-14,10-20.2c1.3-1.6,3.1-2.9,4.6-4.4c1.8-1.1,3.7-2.4,5.7-3.1c4.1-1.6,8.3-2,12-2.1c7.6-0.2,13.8-0.4,18.8-2.9 c0.9-0.4,1.8-1,2.6-1.6l0.1-0.1c2.3-2.8,3.8-6,4.5-9.5c0.7-3.4,0.5-6.9-0.7-10.3c-2.5-7.7-6.6-14.4-12.3-20.2 c-4-4.1-8.6-6.2-13.9-7.6c-0.1,0-0.1,0-0.1,0c-1.1-0.3-2.3-0.6-3.5-0.8c0,0-6.9-1.4-12.1-1.8c-2.7,0-5.4,0.1-8,0.2 c-5.7,0.4-11,1.3-15.3,4c-4.4,2.6-8.1,7-11.8,11.7c-1.1,1.5-3.2,1.7-4.6,0.6c-1.3-1-1.6-2.9-0.7-4.3 c3.3-5,6.8-10.5,12.6-14.7c0,0,0.1-0.1,0.1-0.1c4.4-3.3,4.6-9.7,0.3-13.1c-1.3-1-2.6-2-3.8-3c-2.6-2-5.2-3.8-7.8-5.2 c-2.6-1.1-5-1.5-7.4-0.9l-0.3,0.1c-1.7,0.5-3.5-0.5-4-2.3c-0.4-1.6,0.4-3.2,1.9-3.8c4.2-1.7,8.9-1.2,12.6,0.2 c3.6,1.5,6.8,3.3,9.6,5.2c5.9,3.8,11.2,7.5,16.9,10.3c3.8,1.9,7.8,3.3,11.8,4.2c1.1-0.1,2.1-0.2,3.2-0.2 c7.3-0.4,14.4-3.6,19.2-9.2c0.2-0.2,0.4-0.4,0.6-0.6c11-12.8,16.5-25.6,16.4-39.2c0-2.2-0.2-4.3-0.5-6.5 c-1.8-4.8-5.8-8.5-10.8-9.9c-2.4-0.6-5-0.9-7.6-1.2c-2.3-0.3-3.7-0.2-6.1-0.5c-4.6-0.5-9.2-1.8-13.3-3.3 c-4.1-1.6-7.7-3.3-11.4-4.4c-3.6-1.2-7.3-1.7-11.3-1.7c-1.8,0-3.3-1.5-3.2-3.3c0-1.7,1.3-3,2.9-3.1 c4.4-0.6,9.1-0.5,13.6,0.3c4.4,0.8,8.6,2.2,12.4,3c5.6,1.4,10.9,1.6,16.5,1c-4-2.9-8.9-5.4-14-8.2 c-5.3-2.9-10.7-6.2-15.2-10.8c-4.6-4.5-7.9-10.1-10-16c-0.6-1.7,0.3-3.5,2-4.1c1.6-0.6,3.3,0.1,4,1.6 c2.4,5,5.5,9.2,9.6,12.6c4,3.4,8.8,5.8,14.1,8c4.4,2,9.2,3.8,14,6.4c0.1-3,0.2-5.9,0.2-8.4c0.1-3.5-0.3-6.2-1.8-8.4 c-1.5-2.4-4.2-4.4-7.3-6c-1.7-1-2.3-2.9-1.4-4.5c0.8-1.4,2.5-2,4.1-1.5c3.8,1.5,7.9,3.3,11.1,6.9c3.4,3.6,4.7,8.6,5.1,12.6 c0.5,4.2,0.7,7.8,1.2,11.2c0.6,3.4-0.1,6.8,4.3,13.3l1.3,1.6c2.7,3.2,6.6,5.2,10.8,5.7c13,1.6,24.6-0.2,36.8-7.7 c7.3-4.5,12.9-11.3,15.8-19.2c0.8-2.1,1.5-4.3,2.1-6.5c1.7-6.8,2.7-13.9,3.2-21s0.3-14.3-0.2-21.6 c-0.6-7.1-1.5-14.4-3-21.4c-0.4-1.8,0.8-3.5,2.5-3.9s3.3,0.6,3.8,2.2c2.1,7.4,3.6,14.7,4.7,22.1c1.1,6.9,1.7,14,1.9,21 c1.6-1,3.3-2.2,4.8-3.4c3.4-2.6,6.4-5.7,8.9-9.2s4.6-7.3,6-11.4c1.6-4.1,2.3-8.5,2.8-12.8V8.2c0.2-1.8,1.8-3.1,3.6-2.9 c1.6,0.1,2.8,1.5,2.8,3.1c0.1,4.9-0.1,10-1.4,15c-1.5,7.1-4.9,14-9.3,20c-1.8,2.6-3.9,4.9-6.1,7.1 c-3.7,3.6-7.4,6.6-12.5,9.5c-0.5,3.4-0.8,6.7-1.4,10.1c-0.3,1.4-0.7,2.9-1.1,4.4c-2.1,8.6-0.5,17.9,4.8,25 c4.4,5.9,9.9,10.2,16.4,13.3c6.6,3.1,14.1,3.3,21.3,1.5h0.1c2.2-0.7,4.4-1.5,6.4-2.5c5.2-2.3,9.9-5.4,13.3-9.2 c1.7-1.9,3-4.1,3.8-6.3c0.4-1.1,0.7-2.3,0.8-3.5c0.2-1.1,0.4-3.3,0.7-4.9c1.5-6.8,4.8-13.3,10.8-18 c1.4-1.1,3.4-0.9,4.5,0.5c1,1.3,0.9,3.1-0.3,4.2l-0.4,0.3c-3.4,3.4-5.7,8.9-6,14.1c-0.2,1.5,0,2.4-0.1,4.3 c-0.1,1.8-0.4,3.7-0.9,5.5c-0.9,3.5-2.7,6.9-4.8,9.7c11.4-2.5,23-5.9,29.8-14.4c1.2-1.4,3.3-1.7,4.7-0.6 c1.3,1,1.6,2.9,0.6,4.3c-3.9,5.9-9.7,10.1-15.6,13.2C255.4,115,249.2,117.1,243,119z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000047750263120387055530000013771309759744037775_",
    x: 81.3,
    y: 98.7,
    width: 125.3,
    height: 120
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122682669794659111130000011883939537820111254_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047750263120387055530000013771309759744037775_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122682669794659111130000011883939537820111254_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000139987593915276218790000003845092811732820921_",
    x: 5.2,
    y: 17.3,
    transform: "matrix(0.9298 -0.368 0.368 0.9298 -48.889 66.221)",
    width: 288,
    height: 288
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080911044387593559210000007661932433743170199_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139987593915276218790000003845092811732820921_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080911044387593559210000007661932433743170199_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000147936147933816217890000003147927455927179140_",
    x: 5.2,
    y: 17.3,
    transform: "matrix(0.9298 -0.368 0.368 0.9298 -48.889 66.221)",
    width: 288,
    height: 288
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072255519210933228550000015755278616948689844_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147936147933816217890000003147927455927179140_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000072255519210933228550000015755278616948689844_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M157.9,218.4c-4-3.3-8.7-5.8-13.9-7.3c-3.5-1.1-8.7-2.5-12.8-2.8c-0.9-0.1-2.6-0.1-4.6,0.1 c-5.4,0.5-10.8,1.9-16,3.9c-0.9,0.3-1.7,0.7-2.5,1.1c-0.2-2.8-0.8-5.5-1.7-8.2c-3.1-9.5-8.3-18.1-15.5-25.4 c-2.7-2.8-5.7-5-9.1-6.9c1.7-1.4,3.3-3,4.8-4.6L87,168c13.7-16,20.2-31.7,20-48.6c0-1.2-0.1-2.4-0.1-3.5 c11.9,1.2,22.2-0.1,32.3-4.1c3.9-1.5,7.7-3.5,11.5-5.8c3.3-2.1,6.5-4.5,9.2-7.2c1.3,3.5,3.1,6.7,5.3,9.7 c5.6,7.5,12.8,13.4,21.5,17.5c3.7,1.8,7.8,3,11.9,3.5c-1.4,2.9-2.3,6-2.6,9.3c-0.8,8.8,0.1,17.7,2.5,26.5 c1.5,5.6,3.9,10.8,7.2,15.5c-4.2,0.5-8.3,1.6-12.2,3.1c-2.4,0.9-4.7,2.1-6.9,3.3c-8.4,4.9-15.9,11-21.7,17.7 C161.5,209,159.1,213.6,157.9,218.4z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000090994221978082684170000007772109217223191706_",
    x: 113.3,
    y: 126.7,
    width: 70.7,
    height: 69.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072246089438931592010000014240817280557668004_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090994221978082684170000007772109217223191706_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000072246089438931592010000014240817280557668004_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000158022945715048342570000005746896660073292437_",
    x: 5.2,
    y: 17.3,
    transform: "matrix(0.9298 -0.368 0.368 0.9298 -48.889 66.221)",
    width: 288,
    height: 288
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005240884423507230730000010851976091333577117_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158022945715048342570000005746896660073292437_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000005240884423507230730000010851976091333577117_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000149359596602082707900000001929464780971860405_",
    x: 5.2,
    y: 17.3,
    transform: "matrix(0.9298 -0.368 0.368 0.9298 -48.889 66.221)",
    width: 288,
    height: 288
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000079474220334840156980000002338079838188572856_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149359596602082707900000001929464780971860405_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000079474220334840156980000002338079838188572856_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M180.6,148.6c0.4,1,0.8,2.1,1.1,3.2c0.3,1.1,0.6,2.2,0.8,3.3s0.3,2.2,0.4,3.3c0.1,1.1,0.1,2.2,0.1,3.4 c0,1.1-0.1,2.2-0.2,3.4c-0.1,1.1-0.3,2.2-0.5,3.3s-0.5,2.2-0.9,3.2c-0.3,1.1-0.7,2.1-1.2,3.1c-0.4,1-0.9,2-1.5,3 c-0.5,1-1.1,1.9-1.8,2.9c-0.6,0.9-1.3,1.8-2,2.7s-1.5,1.7-2.3,2.5s-1.6,1.5-2.5,2.2s-1.8,1.3-2.7,2 c-0.9,0.6-1.9,1.2-2.9,1.7s-2,1-3.1,1.4c-1,0.4-2.1,0.8-3.2,1.1c-1.1,0.3-2.2,0.6-3.3,0.8s-2.2,0.3-3.3,0.4 c-1.1,0.1-2.2,0.1-3.4,0.1c-1.1,0-2.2-0.1-3.3-0.2c-1.1-0.1-2.2-0.3-3.3-0.5s-2.2-0.5-3.2-0.9c-1.1-0.3-2.1-0.7-3.1-1.2 c-1-0.4-2-0.9-3-1.5c-1-0.5-1.9-1.1-2.8-1.8c-0.9-0.6-1.8-1.3-2.7-2c-0.9-0.7-1.7-1.5-2.5-2.3s-1.5-1.6-2.2-2.5 s-1.3-1.8-2-2.7c-0.6-0.9-1.2-1.9-1.7-2.9s-1-2-1.4-3.1c-0.4-1-0.8-2.1-1.1-3.2c-0.3-1.1-0.6-2.2-0.8-3.3 c-0.2-1.1-0.3-2.2-0.4-3.3s-0.1-2.2-0.1-3.4c0-1.1,0.1-2.2,0.2-3.3s0.3-2.2,0.5-3.3s0.5-2.2,0.9-3.2 c0.3-1.1,0.7-2.1,1.2-3.1c0.4-1,0.9-2,1.5-3c0.5-1,1.1-1.9,1.8-2.9c0.6-0.9,1.3-1.8,2-2.7s1.5-1.7,2.3-2.5s1.6-1.5,2.5-2.2 s1.8-1.3,2.7-2c0.9-0.6,1.9-1.2,2.9-1.7s2-1,3.1-1.4c1-0.4,2.1-0.8,3.2-1.1c1.1-0.3,2.2-0.6,3.3-0.8 c1.1-0.2,2.2-0.3,3.3-0.4s2.2-0.1,3.4-0.1c1.1,0,2.2,0.1,3.3,0.2s2.2,0.3,3.3,0.5s2.2,0.5,3.2,0.9c1.1,0.3,2.1,0.7,3.1,1.2 c1,0.4,2,0.9,3,1.5c1,0.5,1.9,1.1,2.8,1.8c0.9,0.6,1.8,1.3,2.7,2s1.7,1.5,2.4,2.3c0.8,0.8,1.5,1.6,2.2,2.5s1.3,1.8,2,2.7 c0.6,0.9,1.2,1.9,1.7,2.9C179.7,146.5,180.2,147.5,180.6,148.6z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000034083132393037493480000014349054532405858435_",
    x: 140,
    y: 158.7,
    width: 36,
    height: 34.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014595986220490067420000013731794710639102127_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034083132393037493480000014349054532405858435_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000014595986220490067420000013731794710639102127_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000021799054706911801280000014358769098681168534_",
    x: 5.2,
    y: 17.3,
    transform: "matrix(0.9298 -0.368 0.368 0.9298 -48.889 66.221)",
    width: 288,
    height: 288
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139280138264848345650000010011005223538868883_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021799054706911801280000014358769098681168534_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139280138264848345650000010011005223538868883_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000183960421414946728960000008086180738965789826_",
    x: 5.2,
    y: 17.3,
    transform: "matrix(0.9298 -0.368 0.368 0.9298 -48.889 66.221)",
    width: 288,
    height: 288
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063628770179519339560000009657236225694587782_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183960421414946728960000008086180738965789826_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000063628770179519339560000009657236225694587782_)"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M174.2,169.5c0.4,1,0.7,2.1,0.9,3.2c0.2,1.1,0.3,2.2,0.3,3.3s-0.1,2.2-0.4,3.3c-0.2,1.1-0.6,2.2-1,3.2 s-1,2-1.6,2.9s-1.4,1.8-2.2,2.6s-1.7,1.5-2.6,2.1c-0.9,0.6-1.9,1.1-3,1.5c-1,0.4-2.1,0.7-3.2,0.9c-1.1,0.2-2.2,0.3-3.3,0.3 s-2.2-0.1-3.3-0.4c-1.1-0.2-2.2-0.6-3.2-1s-2-1-2.9-1.6s-1.8-1.4-2.6-2.2s-1.5-1.7-2.1-2.6c-0.6-0.9-1.1-1.9-1.5-3 c-0.4-1-0.7-2.1-0.9-3.2c-0.2-1.1-0.3-2.2-0.3-3.3s0.1-2.2,0.4-3.3c0.2-1.1,0.6-2.2,1-3.2s1-2,1.6-2.9s1.4-1.8,2.2-2.6 s1.7-1.5,2.6-2.1c0.9-0.6,1.9-1.1,3-1.5c1-0.4,2.1-0.7,3.2-0.9c1.1-0.2,2.2-0.3,3.3-0.3s2.2,0.1,3.3,0.4 c1.1,0.2,2.2,0.6,3.2,1s2,1,2.9,1.6s1.8,1.4,2.6,2.2s1.5,1.7,2.1,2.6C173.2,167.5,173.7,168.5,174.2,169.5z"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarNeuron);
export default __webpack_public_path__ + "static/media/navbar-neuron.255d0bc07acf1946fb915ca387587ac9.svg";
export { ForwardRef as ReactComponent };